import { AnimateBox } from '../../components/animate-box'
import { Wrap } from '../../components/wap'
import { STATIC_OBS_URL } from '../../consts'

import type { PageContent } from '../../pageContents'

export interface ProductsDetailProps {
  data: PageContent
}

export const ProductsDetail = (props: ProductsDetailProps) => {
  const { data } = props
  const { html, name, title } = data

  return (
    <Wrap className='products-detail'>
      <div className='public-banner-box'>
        <div
          className='mask'
          style={{
            backgroundImage: `url(${STATIC_OBS_URL}/website/home/products/detail-banner.jpg)`
          }}
        />
        <AnimateBox tagName='h2'>{name}</AnimateBox>
        <AnimateBox animateDelay={0.5} tagName='p'>
          {title}
        </AnimateBox>
      </div>
      <div className='wrap'>
        <div>
          <div className='rich-content' dangerouslySetInnerHTML={{ __html: html || '' }} />
        </div>
      </div>
    </Wrap>
  )
}
